import { render, staticRenderFns } from "./ShippingBatchesContentFilter.vue?vue&type=template&id=67bcd74e&"
import script from "./ShippingBatchesContentFilter.vue?vue&type=script&lang=js&"
export * from "./ShippingBatchesContentFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports